import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=1ff32995&scoped=true&"
import script from "./InvoiceList.vue?vue&type=script&lang=js&"
export * from "./InvoiceList.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceList.vue?vue&type=style&index=0&id=1ff32995&scoped=true&lang=css&"
import style1 from "./InvoiceList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff32995",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ff32995')) {
      api.createRecord('1ff32995', component.options)
    } else {
      api.reload('1ff32995', component.options)
    }
    module.hot.accept("./InvoiceList.vue?vue&type=template&id=1ff32995&scoped=true&", function () {
      api.rerender('1ff32995', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Invoices/NewDocumentRelated/InvoiceList.vue"
export default component.exports